import '../../../../styles/invoice.css';

import React, {
  useEffect,
  useState,
} from 'react';

// Material
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import ListWithFilter
  from '../../../../components/list/listWithFilter.component';
import CustomProgress from '../../../../components/Progress/progress.component';
import { useEmployees } from '../../../../hooks/useEmployees';
import { useRegisterEmployee } from '../../../../hooks/useRegisterEmployee';
import { useWindowSize } from '../../../../hooks/useResizeWindows';
import DATA_NOT_FOUND_IMAGE
  from '../../../../images/NotificacionesColfactura.png';
import { TypesTabEmployee } from '../../../../types/TypesTabEmployee.js';
import Buttons from '../components/actionButtons';
// Components
import Detail from '../components/detail';

const useStyles = makeStyles((theme) => ({
  txtFilter: {
    margin: '10px 0px 10px 0px',
    color: theme.palette.primaryColor,
  },
  datanotfound: {
    display: 'block',
    marginTop: '5%',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    textAlign: 'center',
  },
  datanotfoundText: {
    color: theme.palette.primaryColor,
    fontSize: '30px',
    fontWeight: '400',
    fontFamily: 'Muli',
  },
}));

const Removes = ({ setContentTab, setBulkLoad }) => {
  const classes = useStyles();
  const [employeeIdSelected, setEmployeeIdSelected] = useState(null);
  const [heightList, setHeightList] = useState(0);
  const {
    changeOpenRegisterEmployee,
    changeEditingStatus,
    loadingGetEmployees,
    listFilterEmployeeRemoves,
    employeeDetail,
    fillEmployeeById,
    loadingDetailEmployee,
  } = useEmployees();

  const { setReintegreStatus } = useRegisterEmployee();

  const { height } = useWindowSize();

  /**
   * Consulta Información de primer empleado en la lista
   */
  useEffect(() => {
    if (listFilterEmployeeRemoves?.length > 0) {
      const id = listFilterEmployeeRemoves[0].id;
      fillEmployeeById(id);
      setEmployeeIdSelected(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listFilterEmployeeRemoves]);

  //Lee altura de pantalla
  useEffect(() => {
    const windowsHeight = height ?? 0;
    const discount = windowsHeight * 0.19;
    setHeightList(windowsHeight - discount);
  }, [height]);

  /**
   * Escucha evento selección de empleado
   * @param {*} item
   */
  const handleEmployeeSelection = (item) => {
    fillEmployeeById(item.id);
    setEmployeeIdSelected(item.id);
  };

  /**
   * Abre formulario para edición de empleado e modo reintegro
   */
  const handleReintegrate = () => {
    setReintegreStatus(true);
    changeOpenRegisterEmployee(true);
    changeEditingStatus(true);
  };

  return (
    <>
      <Grid container spacing={1}>
        {listFilterEmployeeRemoves?.length > 0 ? (
          <>
            <Grid item lg={5} md={6} sm>
              {!loadingGetEmployees ? (
                <ListWithFilter
                  list={listFilterEmployeeRemoves}
                  textSearch="Buscar empleado por nombre o documento"
                  onClick={(item) => {
                    handleEmployeeSelection(item);
                  }}
                  selectedId={employeeIdSelected}
                  maxHeight={heightList}
                  showFilter={false}
                />
              ) : (
                <div style={{ paddingTop: 20 }}>
                  <CustomProgress />
                </div>
              )}
            </Grid>
            <Grid item lg={7} md={6} sm>
              <Buttons setBulkLoad={setBulkLoad} />
              {!loadingDetailEmployee &&
              employeeIdSelected === employeeDetail?.id ? ( //Debe ser loadingDetail
                <Detail
                  changeEditingStatus={changeEditingStatus}
                  setContentTab={setContentTab}
                  employeeDetail={employeeDetail}
                  type={TypesTabEmployee.Retirados}
                  changeOpenRegisterEmployee={changeOpenRegisterEmployee}
                  handleReintegrate={handleReintegrate}
                />
              ) : (
                <div style={{ paddingTop: 20 }}>
                  <CustomProgress />
                </div>
              )}
            </Grid>
          </>
        ) : (
          <>
            <Grid item lg={5} md={6} sm></Grid>
            <Grid item lg={7} md={6} sm>
              <Buttons setBulkLoad={setBulkLoad} />
            </Grid>
            <Grid container>
              <Grid item lg={12} xs={12} className={classes.datanotfound}>
                <img src={DATA_NOT_FOUND_IMAGE} alt="Datos no encontrados" />
                <div className={classes.datanotfoundText}>
                  No tienes Empleados Retirados
                </div>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default Removes;
